if (!customElements.get('product-card-gallery')) {
  class ProductCardGallery extends HTMLElement {
    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('[data-card-gallery-image]'));
      this.currentLabel = this.querySelector('[data-card-gallery-current]');
      this.index = Number(this.dataset.index || 0);
      this.querySelector('[data-card-gallery-prev]')?.addEventListener('click', (event) => this.move(event, -1));
      this.querySelector('[data-card-gallery-next]')?.addEventListener('click', (event) => this.move(event, 1));
      this.update();
    }

    move(event, direction) {
      event.preventDefault();
      event.stopPropagation();
      if (this.images.length < 2) return;
      this.index = (this.index + direction + this.images.length) % this.images.length;
      this.update();
    }

    update() {
      this.images.forEach((image, index) => {
        const active = index === this.index;
        image.hidden = !active;
        image.classList.toggle('is-active', active);
      });
      if (this.currentLabel) this.currentLabel.textContent = String(this.index + 1);
      this.dataset.index = String(this.index);
    }
  }
  customElements.define('product-card-gallery', ProductCardGallery);
}
